export enum SymptomOccurrences {
  IMMEDIATE = 'Immediate',
  EARLY = 'Early',
  LATE = 'Late',
  DELAYED = 'Delayed',
}
